module.exports = __webpack_public_path__ + "static/media/Polygon7.ba5afa7e.svg";